exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".styles__dropdownMenu___1HAXu{z-index:999;width:140px;position:absolute;top:20px;right:90px;padding-top:20px;font-size:14px;color:#333}.styles__dropDownMenu___RzG3f:hover{display:block}.styles__dropdownMenu___1HAXu ul{box-shadow:0 2px 16px 0 rgba(0,0,0,.1);background:#fff;margin:0;padding:0}.styles__dropdownMenu___1HAXu ul li{padding:10px 20px;list-style:none;cursor:pointer}.styles__dropdownMenu___1HAXu ul li.styles__active___102yk{color:#f8d0ca}.styles__dropdownMenu___1HAXu ul li:hover{background:#fff4f2}", ""]);

// exports
exports.locals = {
	"dropdownMenu": "styles__dropdownMenu___1HAXu",
	"dropDownMenu": "styles__dropDownMenu___RzG3f",
	"active": "styles__active___102yk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/currency-menu/styles.css
// module id = 673
// module chunks = 0